import { useEffect } from 'react';
import { useGlobalPreview } from './useGlobalPreview';

/**
 * Hook for editor pages to activate the global preview panel
 * and get access to send updates.
 *
 * Usage:
 *   const { sendUpdate, sendMediaUpdate } = useEditorPreview('/');
 */
export function useEditorPreview(page = '/') {
  const preview = useGlobalPreview();

  // Auto-open preview when an editor page mounts
  useEffect(() => {
    preview.setIsOpen(true);
    if (page !== preview.currentPage) {
      preview.setCurrentPage(page);
    }
    // Don't close on unmount — let it persist
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return {
    sendUpdate: preview.sendUpdate,
    sendMediaUpdate: preview.sendMediaUpdate,
    injectDesignVariables: preview.injectDesignVariables,
    scrollToSection: preview.scrollToSection,
    scrollToField: preview.scrollToField,
    toggleSection: preview.toggleSection,
    highlightField: preview.highlightField,
    highlightBySelector: preview.highlightBySelector,
    iframeRef: preview.iframeRef,
    isPreviewOpen: preview.isOpen,
    triggerPreview: preview.triggerPreview,
    setPreviewDirty: preview.setPreviewDirty,
  };
}
